import React from 'react';
import { X } from 'lucide-react';
import LoadingIndicator from 'components/organisms/ai-chat/loadingIndicator';
import ExplainerMarkdownContent from './explainer-markdown-content';

export interface FeatureExplainerModalProps {
	open: boolean;
	onClose: () => void;
	loading: boolean;
	explanation: string;
	error: string | null;
}

const FeatureExplainerModal: React.FC<FeatureExplainerModalProps> = ({
	open,
	onClose,
	loading,
	explanation,
	error,
}) => {
	if (!open) {
		return null;
	}

	return (
		<div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
			<button
				type="button"
				className="absolute inset-0 bg-black/40"
				aria-label="Close"
				onClick={onClose}
			/>
			<div
				className="relative z-10 w-full max-w-2xl max-h-[85vh] flex flex-col rounded-2xl bg-white shadow-elev-3-popover border border-tertiary-background"
				role="dialog"
				aria-modal="true"
			>
				<div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-tertiary-background">
					<h2 className="text-lg font-semibold text-primary-text">Page Explainer</h2>
					<button
						type="button"
						onClick={onClose}
						className="p-2 rounded-full text-light-grey hover:bg-tertiary-background hover:text-primary-text transition-colors"
						aria-label="Close dialog"
					>
						<X className="w-5 h-5" />
					</button>
				</div>
				<div className="px-5 py-4 overflow-y-auto flex-1 min-h-0">
					{loading && (
						<div className="flex flex-col items-center justify-center gap-4 py-12">
							<LoadingIndicator />
							<p className="text-ui text-gray-600">Analysing your screen…</p>
						</div>
					)}
					{!loading && error && (
						<p className="text-ui text-red-600 whitespace-pre-wrap">{error}</p>
					)}
					{!loading && !error && explanation && (
						<ExplainerMarkdownContent markdown={explanation} />
					)}
					{!loading && !error && !explanation && (
						<p className="text-ui text-gray-600">No explanation returned.</p>
					)}
				</div>
			</div>
		</div>
	);
};

export default FeatureExplainerModal;
